export default "__VITE_ASSET__Dx58vmO9__"